import api from './../../lib/api';

// Экшены
export const PIXELS_LIST_LOAD = "PIXELS_LIST_LOAD";
export const PIXEL_LOAD       = "PIXEL_LOAD";
export const PIXEL_CREATE     = "PIXEL_CREATE";
export const PIXEL_UPDATE     = "PIXEL_UPDATE";
export const PIXEL_DELETE     = "PIXEL_DELETE";

// Мутации
const PIXELS_LIST_CHANGE     = "PIXELS_LIST_CHANGE";
const PIXELS_LIST_LOADING_CHANGE = "PIXELS_LIST_LOADING_CHANGE";
const PIXEL_CHANGE           = "PIXEL_CHANGE";
const PIXEL_LOADING_CHANGE   = "PIXEL_LOADING_CHANGE";
const PIXEL_SAVING_CHANGE    = "PIXEL_SAVING_CHANGE";
const PIXEL_ERRORS_CHANGE    = "PIXEL_ERRORS_CHANGE";

const state = {
  pixels: [],
  pixels_loading: false,
  pixel: null,
  pixel_loading: false,
  pixel_saving: false,
  pixel_errors: {},
};

const actions = {
  /**
   * Получить список пикселей (с фильтрами)
   * params = { filter: { name: '', code: '', ids: '1,2', is_active: 1 } }
   */
  [PIXELS_LIST_LOAD]({ commit, state }, params) {
    return api.list(
      'pixels',
      0,
      params,
      state,
      commit,
      PIXELS_LIST_LOADING_CHANGE,
      PIXELS_LIST_CHANGE
    )
  },

  /**
   * Получить один пиксель
   */
  [PIXEL_LOAD]({ commit, state }, id) {
    return api.load(
      'pixel',
      id,
      state,
      commit,
      PIXEL_LOADING_CHANGE,
      PIXEL_CHANGE
    );
  },

  /**
   * Создать пиксель
   * pixel = { name, type, code, is_active }
   */
  [PIXEL_CREATE]({ commit, state }, pixel) {
    const model = {
      name: pixel.name,
      type: pixel.type,
      code: pixel.code,
      is_active: pixel.is_active ?? true,
    };

    return api.createWithData(
      "pixels",
      null,
      model,
      state,
      commit,
      PIXEL_SAVING_CHANGE,
      PIXEL_CHANGE,
      PIXEL_ERRORS_CHANGE
    )
  },

  /**
   * Обновить пиксель
   */
  [PIXEL_UPDATE]({ commit, state }, { id, pixel }) {
    const model = {
      name: pixel.name,
      type: pixel.type,
      code: pixel.code,
      is_active: pixel.is_active ?? true
    };

    return api.update(
      'pixel',
      id,
      model,
      state,
      commit,
      PIXEL_SAVING_CHANGE,
      PIXEL_CHANGE,
      PIXEL_ERRORS_CHANGE
    );
  },

  /**
   * Удалить пиксель
   */
  [PIXEL_DELETE](_, id) {
    return api.delete('pixel', id);
  }
};

const mutations = {
  [PIXELS_LIST_CHANGE](state, data) {
    if (!data) {
      state.pixels = [];
    } else if (Array.isArray(data)) {
      state.pixels = data;
    } else if (data.data && Array.isArray(data.data)) {
      state.pixels = data.data;
    } else {
      state.pixels = [];
    }
  },
  [PIXELS_LIST_LOADING_CHANGE](state, loading) {
    state.pixels_loading = loading;
  },
  [PIXEL_CHANGE](state, data) {
    state.pixel = data;
  },
  [PIXEL_LOADING_CHANGE](state, loading) {
    state.pixel_loading = loading;
  },
  [PIXEL_SAVING_CHANGE](state, saving) {
    state.pixel_saving = saving;
  },
  [PIXEL_ERRORS_CHANGE](state, errors) {
    state.pixel_errors = errors;
  }
};

export default {
  state,
  actions,
  mutations
};
